module.exports = __webpack_public_path__ + "8f1ae807826d970b4ca15a5641838d07.jpg";